import styled, { css, keyframes } from 'styled-components';

export const Loader = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  perspective: 800px;
  margin-left: 10px;
`;

const Inner = css`
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

const OneAnimation = keyframes`
0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
`;

const TwoAnimation = keyframes`
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
`;

const ThreeAnimation = keyframes`
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
`;

interface IInner {
  inverted?: boolean;
}

export const One = styled.div<IInner>`
  ${Inner}
  left: 0%;
  top: 0%;
  animation: ${OneAnimation} 1s linear infinite;
  border-bottom: 3px solid
    ${(props) =>
      props.inverted ? props.theme.colors.white : props.theme.colors.black};
`;

export const Two = styled.div<IInner>`
  ${Inner}
  right: 0%;
  top: 0%;
  animation: ${TwoAnimation} 1s linear infinite;
  border-right: 3px solid
    ${(props) =>
      props.inverted ? props.theme.colors.white : props.theme.colors.black};
`;

export const Three = styled.div<IInner>`
  ${Inner}
  right: 0%;
  bottom: 0%;
  animation: ${ThreeAnimation} 1s linear infinite;
  border-top: 3px solid
    ${(props) =>
      props.inverted ? props.theme.colors.white : props.theme.colors.black};
`;
